"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.search = undefined;

var _merge = require("lodash/merge");

var _merge2 = _interopRequireDefault(_merge);

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var search = exports.search = function search() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = {};

    switch (action.type) {
        case actionTypes.SAVE_QUERY_INFO:
            nextState.queryInfo = action.queryInfo;
            nextState = (0, _merge2.default)({}, state, nextState);
            return nextState;
            break;
        case actionTypes.SET_SEARCH_QUERY:
            nextState.query = action.query;
            return (0, _merge2.default)({}, state, nextState);
            break;
        case actionTypes.FETCH_AUTOCOMPLETE_TERMS_SUCCESS:
            state.autocompleteTerms = action.response;
            return state;
            break;
        default:
            return state;
            break;
    }

    return Object.assign({}, state, nextState);
};